import { Loader2 } from 'lucide-react'
import { useBreadcrumbPageTitle } from '@/components/layout/DashboardBreadcrumbContext'
import { PageHeader } from '@/features/invitee/components/PageHeader'
import { ChangeReasonModal } from '@features/document-management/components/ChangeReasonModal'
import { PRIMARY_BRAND } from '../utils/constants'
import { SendTestMailModal } from '../components/SendTestMailModal'
import { useEmailTemplateAddEditPage } from '../hooks/useEmailTemplateAddEditPage'
import { EmailTemplateAddEditForm } from '../components/EmailTemplateAddEditForm'

export function EmailTemplateAddEditPage() {
  const page = useEmailTemplateAddEditPage()
  useBreadcrumbPageTitle(
    page.isEdit ? page.templateDetail?.template_name ?? null : null,
  )

  if (page.loadingList) {
    return (
      <div
        className="flex min-h-screen items-center justify-center bg-slate-50/50"
        data-testid="email-template-addedit-loading"
      >
        <Loader2 className="h-8 w-8 animate-spin" style={{ color: PRIMARY_BRAND }} />
      </div>
    )
  }

  return (
    <div
      className="min-h-screen min-w-0 bg-[#f8fafc] font-sans text-slate-900 pb-12"
      data-testid="email-template-addedit-page"
    >
      <PageHeader
        title={page.isEdit ? 'Edit Email Template' : 'Add Email Template'}
        testIdRoot="email-template-page-header"
      />

      <div
        className="mx-auto flex w-full min-w-0 flex-col gap-4 px-3 py-4 sm:gap-6 sm:px-6 sm:py-8"
        data-testid="email-template-addedit-main"
      >
        <div
          className="bg-white shadow-sm border border-slate-200 overflow-visible rounded-lg ring-1 ring-slate-100"
          data-testid="email-template-addedit-card"
        >
          {page.isEdit && page.loadingDetail ? (
            <div className="flex min-h-[240px] items-center justify-center p-6 bg-slate-50/50">
              <Loader2 className="h-8 w-8 animate-spin" style={{ color: PRIMARY_BRAND }} />
            </div>
          ) : (
            <EmailTemplateAddEditForm page={page} />
          )}
        </div>

        <ChangeReasonModal
          isOpen={page.reasonOpen}
          submitting={page.saving}
          onClose={() => page.setReasonOpen(false)}
          onSubmit={page.handleReasonSubmit}
        />

        <SendTestMailModal
          isOpen={page.testMailOpen}
          onClose={page.closeTestMail}
          testType={page.testMailType}
          workflowType={page.testMailCtx?.workflowType ?? ''}
          availableVariables={page.testMailCtx?.availableVariables ?? null}
          emailBody={page.testMailCtx?.emailBody ?? ''}
          smsBody={page.testMailCtx?.smsBody ?? ''}
        />
      </div>
    </div>
  )
}
